import { useCallback, useEffect, useState } from 'react';
import { fetchPublishedMembers } from '../../lib/membersApi';
import './Member.scss';

const Member = () => {
  const [members, setMembers] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      setMembers(await fetchPublishedMembers());
    } catch {
      setMembers([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  if (loading) {
    return <div className="member"><p className="member__status">Loading…</p></div>;
  }

  if (members.length === 0) {
    return null;
  }

  return (
    <div className="member">
      {members.map((item) => (
        <a
          className={`member__card ${!item.logo_url ? 'no-image' : ''}`}
          href={item.external_url || '#'}
          target={item.external_url ? '_blank' : undefined}
          rel={item.external_url ? 'noopener noreferrer' : undefined}
          key={item.id}
        >
          {item.logo_url && <img src={item.logo_url} alt={item.name} />}
          <h2>{item.name}</h2>
        </a>
      ))}
    </div>
  );
};

export default Member;
